import { publicAssets } from 'utils/gcs';

const BASE_PATH = '/transition/glitch/';

export const LAYER_IMAGES = [
  'digital_glitch_1.png',
  'digital_glitch_2.png',
  'digital_glitch_3.png',
  'digital_glitch_5.png',
  'digital_glitch_1.png',
  'digital_glitch_2.png',
  'digital_glitch_3.png',
  'digital_glitch_5.png',
].map(fileName => publicAssets(`${BASE_PATH}${fileName}`));
